import { render, staticRenderFns } from "./DelProItem.vue?vue&type=template&id=88848924&scoped=true"
import script from "./DelProItem.vue?vue&type=script&lang=js"
export * from "./DelProItem.vue?vue&type=script&lang=js"
import style0 from "./DelProItem.vue?vue&type=style&index=0&id=88848924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88848924",
  null
  
)

export default component.exports